import React from 'react';

import constants from '../../common/constants';
import { withAppContext } from '../../contexts/AppContext';
import { ContentRequestWithMetaData } from './AllContentSuggestionsView';
import ContentFilters, {
  ContentFiltersProps,
  FilterCategory,
  filterOptionToLabelMap,
} from '../content/ContentFilters';
import {
  ContentRequestState,
  ContentRequestType,
} from '@amzn/awscat-pattern-library-service-model';
import { Box, Button, Link } from '@amzn/awsui-components-core';

export interface ContentRequestFiltersProps extends ContentFiltersProps {
  items: ContentRequestWithMetaData[];
}

class ContentRequestFilters extends ContentFilters<ContentRequestFiltersProps> {
  async componentDidMount() {
    this.updateFilterOptions();
  }

  componentDidUpdate(prevProps: ContentRequestFiltersProps) {
    if (this.props.items !== prevProps.items) {
      this.updateFilterOptions();
    }
  }

  updateFilterOptions = async () => {
    const { items } = this.props;
    const { filterOptions } = this.state;
    const updatedFilterOptions = { ...filterOptions };
    items.forEach((item) => {
      Object.values(filterOptions).forEach((filter) => {
        if (filter && Array.isArray(filter.values)) {
          filter.values.forEach((v) => {
            // @ts-expect-error TS7053 - strict migration
            const filterValue = item[v];
            if (v === FilterCategory.RequestType) {
              if (
                [
                  ContentRequestState.REQUESTED,
                  ContentRequestState.ASSIGNED,
                  ContentRequestState.ACCEPTED,
                ].includes(item.state)
              ) {
                this.updateFilterOptionWithValue(filterValue, filter);
              }
            } else {
              this.updateFilterOptionWithValue(filterValue, filter);
            }
          });
        }
      });
    });
    const hasRequireCodeFilter = items.some((item) => !!item.contentRequestData.requireCode);
    if (
      hasRequireCodeFilter &&
      // @ts-expect-error TS18048 - strict migration
      !Object.keys(updatedFilterOptions.contentType.options).includes(FilterCategory.RequireCode)
    ) {
      // @ts-expect-error TS18048 - strict migration
      updatedFilterOptions.contentType.options.requireCode = {
        count: 0,
        // @ts-expect-error TS2322 - strict migration
        label: filterOptionToLabelMap.get(FilterCategory.RequireCode),
        selected: false,
        value: FilterCategory.RequireCode,
      };
    }
    this.setState({ filterOptions: updatedFilterOptions });
  };

  render() {
    return (
      <div>
        <Box variant="h3">{constants.FILTERS}</Box>
        <Box padding={{ bottom: 'm' }}>
          <Link onClick={this.clearFilters}>{constants.CLEAR_ALL_FILTERS}</Link>
        </Box>
        {this.filterToSections()}
      </div>
    );
  }
}

export default withAppContext(ContentRequestFilters);
